var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 35,
    viewBox: "0 0 27 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5012 34.2884C15.6865 34.2884 17.4795 32.5969 17.6406 30.4502H9.36182C9.52291 32.5969 11.3124 34.2884 13.5012 34.2884Z",
    fill: "#434341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7216 26.5874C24.067 23.6808 23.8849 19.2577 23.8744 18.3821V9.21035C23.8744 4.12189 19.749 0 14.6641 0H12.3317C7.24327 0 3.12137 4.1254 3.12137 9.21035V18.5783C3.08285 19.7865 2.77117 23.8559 0.277719 26.5874C-0.338639 27.2633 0.137637 28.3454 1.05167 28.3454H9.75422H17.2451H25.9476C26.8652 28.349 27.3379 27.2633 26.7216 26.5874Z",
    fill: "#434341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampana);
export default __webpack_public_path__ + "static/media/campana.fbf9736f88f49b9714605f8726137e76.svg";
export { ForwardRef as ReactComponent };